module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("The Hospitality and Perfume of the Bandit")]), _vm._v(" "), _c('p', {
    staticClass: "ch-subtitle"
  }, [_vm._v("A translation and introduction")]), _vm._v(" "), _c('p', {
    staticClass: "ch-author"
  }, [_vm._v("by Mark Glen Bilby")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The "), _c('em', [_vm._v("Hospitality and Perfume of the Bandit")]), _vm._v(" ("), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v("; "), _c('em', [_vm._v("CANT")]), _vm._v(" 78.3) is a short story interpolated into at least two manuscripts of the "), _c('em', [_vm._v("Gospel of Pseudo-Matthew.")]), _vm._v(" The title is not found in either manuscript. It is instead proposed to accent this story’s distinctiveness vis-à-vis other apocryphal narratives about the “good bandit” (or "), _c('em', [_vm._v("bon larron")]), _vm._v(" or "), _c('em', [_vm._v("gute Schächer")]), _vm._v("). Though one of several medieval backstories about the repentant criminal of Luke 23:40–43, "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" is unique in the way it connects the bandit’s hospitality shown to the Holy Family during their exile in Egypt to the conversion of Mary Magdalene and her anointing of the feet of Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The interpolated story appears in certain manuscripts of "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" just after chapter"), _c('em'), _vm._v(" 17, which follows the Gospel of Matthew in relating Herod’s infanticidal command (Matt 2:16) and the angelic warning to Joseph to flee (2:13). The Holy Family encounter the bandit as they travel through the desert on their way to Egypt (v. 1). The bandit is under orders to kill any passersby as a condition for his own survival. The story next details the bandit’s internal dialogue as he puzzles over the dilemma between breaking his bandit gang’s murder pact and killing an old man, a mother, and an infant (2). The bandit finally decides to show them covert sanctuary in his own home. When he first addresses them, he inquires as to their plans, quickly offers them hospitality, and then guides them back to his house where he lives with his wife (3). As the bandit’s wife prepares to bathe their leprous son, the bandit insists instead that the infant Jesus be bathed first; their son’s subsequent bath in the leftover water results in his miraculous healing, leading the bandit to worship Jesus (4). The next day the bandit guides the family as far as a fountain, where Mary washes the garments of the infant Jesus, wringing from them into an alabaster jar a most precious and fragrant perfume, which she gives to the bandit as a reward for his hospitality (5). Later, when the bandit’s family falls into poverty, he sells the perfume at great cost to Mary Magdalene, who is reputed to be a connoisseuse of perfumes (6). When the Magdalene anoints herself with the perfume, it cleanses her body and soul; she uses it subsequently to anoint Jesus in preparation for his death, bringing the ointment’s journey full circle back to Jesus (7). The short story closes with a direct link between the hospitable desert bandit and the criminal who spoke to Jesus on the cross (Luke 23:39–43). "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" 18 then recommences the account of the Holy Family’s flight to Egypt with Jesus taming a cave of dragons.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Manuscripts and Editions")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" appears as an episode in manuscripts of "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(", a highly popular and diffuse set of stories for which some two hundred manuscripts survive. Jan Gijsel’s exhaustive conspectus of manuscripts identifies several textual families of "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" and their earliest witnesses: A (9th cent.), P (9th cent.), Q (12th–13th cent.), and R (13th–14th cent.)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-001",
      "id": "foot_001"
    }
  }, [_vm._v("1")])]), _vm._v(" Another tale of the good bandit, the "), _c('em', [_vm._v("Rebellion of Dimas")]), _vm._v(", appears in a single manuscript of the oldest branch (A"), _c('sup', [_vm._v("1")]), _vm._v("a);"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-002",
      "id": "foot_002"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" appears in two exemplars of the Q"), _c('sup', [_vm._v("3")]), _vm._v(" subfamily (14th–15th cent.):"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-003",
      "id": "foot_003"
    }
  }, [_vm._v("3")])]), _vm._v(" London, British Library, Harley 3199 (12th–14th/15th cent.; Gijsel’s Q"), _c('sup', [_vm._v("3")]), _vm._v("a"), _c('sup', [_vm._v("5")]), _vm._v(", here L); and Vatican, Biblioteca Apostolica Vaticana, Vat. lat. 6300 (15th and 17th cent.; Gijsel’s Q"), _c('sup', [_vm._v("3")]), _vm._v("a"), _c('sup', [_vm._v("7")]), _vm._v(", here V). The good bandit interpolations appear in fols. 104v–106r of the fourteenth- or early fifteenth-century portion of the Harley manuscript and in fols. 118r–119r of the fifteenth-century portion of the Vatican manuscript. In both manuscripts, the texts of "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" continue on to the "), _c('em', [_vm._v("pars altera")]), _vm._v(" (portions of the Latin translation of "), _c('em', [_vm._v("Inf. Gos. Thom.")]), _vm._v("). When Geerard in 1997 published his diplomatic edition of "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(", he knew the story only from the Harley manuscript."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-004",
      "id": "foot_004"
    }
  }, [_vm._v("4")])]), _vm._v(" Close study of the two manuscripts reveals that they both rely on an earlier textual tradition—that is, that V does not depend directly on L. The L manuscript is not only chronologically earlier than V but also more faithful textually to their common ancestor. Even across a relatively brief story, clear editorial tendencies emerge in V."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-005",
      "id": "foot_005"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Literary and Theological Importance")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" is one of at least five stories about the so-called good bandit that were interpolated into major apocryphal texts and compilations."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-006",
      "id": "foot_006"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_c('p', {
    staticClass: "list-num"
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("Reb. Dimas")]), _vm._v(" (= "), _c('em', [_vm._v("CANT")]), _vm._v(" 78.2, also found within "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(","), _c('em'), _vm._v(" between chapters 19 and 20 in Namur, Seminary Library, Lat. 80, fols. 13v–15v and 17r–17v): a twelfth-century Latin story featuring the bandit as a procurator’s son and border guard who defies his father by allowing the Holy Family to escape Israel and flee to Egypt."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-007",
      "id": "foot_007"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" (= "), _c('em', [_vm._v("CANT")]), _vm._v(" 78.4, found within manuscripts of the M2 and M3 families of manuscripts of "), _c('em', [_vm._v("Acts of Pilate")]), _vm._v("): a late twelfth- to early fourteenth-century Byzantine Greek account of the Egyptian bandit showing hospitality to the Holy Family, resulting in the healing of his leprous child and his future blessing by Jesus on the cross."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-008",
      "id": "foot_008"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(" (= "), _c('em', [_vm._v("CANT")]), _vm._v(" 78.1, found within the Arundel form of "), _c('em', [_vm._v("Book about the Birth of the Savior")]), _vm._v(" 111–25): a twelfth- to fourteenth-century Latin story describing how the hospitable Egyptian bandit received healing and wealth from the magical bathwater of Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-009",
      "id": "foot_009"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("Leabhar Breac")]), _vm._v(" 131–32 (Dublin, Royal Irish Academy, 23 P 16 [1230]): this famous ca. 1408–1411 manuscript features a brief story about the bandit as a child encountering the infant Jesus in Egypt, a story quite similar to that summarized in Aelred of Rievaulx’s "), _c('em', [_vm._v("De institutione inclusarum")]), _vm._v(" 30."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-010",
      "id": "foot_010"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Outside of these five interpolations, comparable legends also circulated in several other texts:")]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_c('p', {
    staticClass: "list-num"
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The "), _c('em', [_vm._v("Narrative of Joseph of Arimathea")]), _vm._v(": a late fourth- to early fifth-century Greek narrative likely composed in Palestine that greatly expands the backstories of both bandits, blames the death of Jesus on the good bandit’s righteous theft of relics from the Jerusalem temple, narrates dialogues and correspondence between Jesus and Demas, and describes Demas as the cross-bearer ("), _c('em', [_vm._v("staurophylax")]), _vm._v(") who accompanies Jesus when he appears to Joseph of Arimathea."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-011",
      "id": "foot_011"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("CPG")]), _vm._v(" 4877 ("), _c('em', [_vm._v("De cruce et passione")]), _vm._v("): a fourth/fifth-century Palestinian or Syrian Greek sermon/story falsely attributed to John Chrysostom wherein the bandit is a gentile (indeed a relative of Pilate!) and has a vision in the desert leading to his conversion."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-012",
      "id": "foot_012"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("CPG")]), _vm._v(" 4145.22 ("), _c('em', [_vm._v("In sabbatum sanctum, in passionem domini nostri et latronem")]), _vm._v(") / 4162.3 ("), _c('em', [_vm._v("De satana et morte")]), _vm._v("): a fifth/sixth-century Palestinian sermon/story in Arabic and Georgian with many connections to "), _c('em', [_vm._v("CPG")]), _vm._v(" 4877, but here the bandit’s conversion stems from hearing Jesus preach."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-013",
      "id": "foot_013"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The "), _c('em', [_vm._v("Vision of Theophilus")]), _vm._v(": a sixth-century Coptic text featuring a story in which the good bandit (who is Egyptian) and the evil bandit (who is Jewish) steal the Holy Family’s clothes only later to repent and return them."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-014",
      "id": "foot_014"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_c('em', [_vm._v("Homily on the Church of the Rock")]), _vm._v(" 31–32 (Coptic/Arabic; 17–18 in the Ethiopic recension): originally created around the sixth century, this story is highly similar to and in the same historical neighborhood as "), _c('em', [_vm._v("Vis. Theo")]), _vm._v("., except that it narrates the evil bandit stealing the infant Jesus along with the Holy Family’s clothes!"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-015",
      "id": "foot_015"
    }
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("8."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Syriac "), _c('em', [_vm._v("History of the Virgin")]), _vm._v(", and its retelling in "), _c('em', [_vm._v("(Arab.) Gos. Inf.")]), _vm._v(" 23: a ca. eighth-century text with a story of the good bandit (here called Titus) bribing the evil bandit (here Dumachus) to prevent the robbery of the Holy Family in Egypt."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-016",
      "id": "foot_016"
    }
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-num"
  }, [_vm._v("9."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Arabic "), _c('em', [_vm._v("Apocryphal Gospel of John")]), _vm._v(" 10:1–4 and its translation in the Ethiopic "), _c('em', [_vm._v("Miracles of Jesus")]), _vm._v(" 7:1–4: an originally ca. tenth/eleventh-century story evidencing a selective combination of elements from "), _c('em', [_vm._v("Hist. Vir.")]), _vm._v(" and "), _c('em', [_vm._v("Vis. Theo.")]), _vm._v(", in which the Ethiopic version notably varies from its Arabic predecessor by adding a third bandit character due to a mistranslation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-017",
      "id": "foot_017"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Among the nine legends detailed above, "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" and "), _c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(" show the closest similarities to "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" All three of these short stories share three key elements: they focus on the bandit showing the Holy Family hospitality in his home, they note that he has a wife and a child (“little children” in "), _c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(" at "), _c('em', [_vm._v("Birth Sav.")]), _vm._v(" 114), and they call attention to one or more miraculous healings resulting from a bath taken by Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-018",
      "id": "foot_018"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Latin "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" should be located literarily and historically just between the earlier Byzantine Greek "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" and the later Latin "), _c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(" From "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(", "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" borrows the plot of the bandit exemplifying hospitality and having a leprous child healed by Jesus’s leftover bathwater. To "), _c('em', [_vm._v("Hosp. Oint. Band")]), _vm._v("., "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" lends the idea of the bandit receiving a sacred, relic-like ointment of great financial benefit,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-019",
      "id": "foot_019"
    }
  }, [_vm._v("19")])]), _vm._v(" as well as the parallel between dangerous bandits and dangerous dragons all being subdued by the infant Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-020",
      "id": "foot_020"
    }
  }, [_vm._v("20")])]), _vm._v(" The composition of "), _c('em', [_vm._v("Birth. Sav.")]), _vm._v(", drawing on "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" and other infancy traditions, goes back at least to the eighth century."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-021",
      "id": "foot_021"
    }
  }, [_vm._v("21")])]), _vm._v(" It was apparently sometime in the thirteenth or fourteenth century that the Arundel form of "), _c('em', [_vm._v("Birth. Sav.")]), _vm._v(" developed its story ("), _c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(") based on the one newly interpolated into "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" ("), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The appearance or omission of other themes evident among the legends of the good bandit further elucidates the unique combination of characteristics on display in "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" Quite in keeping with the Byzantine Greek "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" and most medieval Latin stories of the bandit, but quite apart from its Coptic and Ethiopic predecessors listed above, "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" makes no mention of the bandit actually engaging in banditry, perhaps in an effort to elevate the cult of Dysmas. Like "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" and earlier Eastern traditions such as "), _c('em', [_vm._v("(Arab.) Gos. Inf")]), _vm._v("., "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" pictures the infant Jesus as a holy object and instrument with which Mary the Mother dispenses miracles. That said, "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" does stand apart from "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" and other earlier traditions in that no miraculous motivation, either from Jesus or Mary, is noted as the reason for his compassion. It is instead his own internal reflection and dialogue, his own weighing of various courses of actions, and his own sense of right and wrong that lead him to aid the family. The bandit in "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" reflects morally—perhaps even philosophically—endeavoring to do what is right for its own sake. "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" may share with "), _c('em', [_vm._v("Reb. Dimas")]), _vm._v(", "), _c('em', [_vm._v("Leabhar Breac")]), _vm._v(","), _c('em'), _vm._v(" and Aelred of Rievaulx’s "), _c('em', [_vm._v("De institutione inclusarum")]), _vm._v(" the theme of the bandit being a righteous rebel, but here it is rebellion not against his father but instead against his fellow bandits. Another somewhat similar feature between these texts is that "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(", like "), _c('em', [_vm._v("Reb. Dimas")]), _vm._v(" and "), _c('em', [_vm._v("Leabhar Breac")]), _vm._v(", locates the bandit’s encounter with the Holy Family en route"), _c('em'), _vm._v(" between Judea and Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Original Language, Date, and Provenance")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The only two sources for "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" are Latin manuscripts, and there is no reason to think the story’s original language was anything other than Latin. The earliest manuscript, L, was created in the fourteenth century, providing a firm "), _c('em', [_vm._v("terminus ad quem")]), _vm._v(". The two sources for "), _c('em', [_vm._v("Hosp. Oint. Band")]), _vm._v("., which appears to be an adaptation of "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(", also are dated to the fourteenth century. A late twelfth-century "), _c('em', [_vm._v("terminus post quem")]), _vm._v(" is reasonable on the basis of the dependence of "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" on "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(", which may well have circulated around this time when the M2 recension of "), _c('em', [_vm._v("Acts Pil.")]), _vm._v(" first appeared in the manuscript record."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-022",
      "id": "foot_022"
    }
  }, [_vm._v("22")])]), _vm._v(" An interpolation during this time frame nicely fits broader trends in "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" manuscripts in France, most especially the addition of the “pars altera,” as for example in BnF Lat. 11867 (13th cent., Marmoutier). The theme of the bandit as a righteous rebel is certainly already well in evidence by the twelfth century in Aelred of Rievaulx’s "), _c('em', [_vm._v("De institutione inclusarum")]), _vm._v(", and "), _c('em', [_vm._v("Reb. Dimas")]), _vm._v(" and "), _c('em', [_vm._v("Leabhar Breac")]), _vm._v(" also attest to this theme around the same time. Still, while this thematic connection shows a certain historical proximity, it does not currently allow for firmer historical conclusions, given the lack of clear evidence of dependence in either direction between "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" and these three texts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("According to the British Library catalog record, the portion of L containing "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" (fols. 95r–126v) comes from “France or England,” and the remaining pages (fols. 2r–94v) are “probably” from France."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-023",
      "id": "foot_023"
    }
  }, [_vm._v("23")])]), _vm._v(" The French songs concluding the fifteenth-century portion of V suggest an original French provenance, even though that manuscript made its way to Rome and was supplemented with a speech given there at the Accademia degli Humoristi in 1616, as noted in the manuscript dedication. The preponderance of evidence points to an originally French provenance for the story.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Translation")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To date, "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" has appeared only in Geerard’s Latin edition of L. This translation, the first in any modern language, is based on my forthcoming edition, the first collated critical edition using both manuscripts currently known. Erroneous readings by Geerard are indicated in the notes. The text is here divided into seven verses for ease of reading and citation.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Sigla")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("G")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Geerard, “Gute Schächer”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("L")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("London, British Library, Harley 3199")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td10"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("V")])]), _vm._v(" "), _c('td', {
    staticClass: "td85"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vatican, Biblioteca Apostolica Vaticana, Vat. lat. 6300")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "bib-h1"
  }, [_vm._v("Bibliography")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h2"
  }, [_vm._v("EDITIONS AND TRANSLATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Geerard, Maurice. “Gute Schächer: Ein neues unediertes Apokryphon.” Pages 85–89 in "), _c('em', [_vm._v("La spiritualité de l’univers byzantin dans le verbe et l’image.")]), _vm._v(" Edited by Kristoffel Demoen and Jeannine Vereecken. Instrumenta Patristica 30. Steenbrugis: In Abbatia S. Petri; Turnhout: Brepols, 1997. (Diplomatic edition based on L.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib-h2"
  }, [_vm._v("STUDIES")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bilby, Mark G. "), _c('em', [_vm._v("As the Bandit Will I Confess You: Luke 23, 39–43 in Early Christian Interpretation.")]), _vm._v(" Turnhout: Brepols; Strasbourg: University of Strasbourg, 2013. (Further bibliography may be found here.)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Billiard, Carine. “Présentation et description du manuscrit 80 (Grand Séminaire Salzinnes-Namur).” 2 vols. Mémoire de licence en histoire, Louvain-la-Neuve, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Esbroeck, Michel van. “Une homélie inédite éphrémienne sur le bon larron en grec, géorgien et arabe.” "), _c('em', [_vm._v("AnBoll")]), _vm._v(" 101 (1983): 327–62.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Geerard, Maurice. “Le bon larron, un apocryphe inédit.” Pages 355–63 in "), _c('em', [_vm._v("Philologia Sacra: Biblische und patristische Studien für Hermann J. Frede und Walter Thiele zu ihrem siebzigsten Geburtstag")]), _vm._v(", Band 2, "), _c('em', [_vm._v("Apocryphen, Kirchenväter, Verschiedenes")]), _vm._v(". Edited by Roger Gryson. GLB 24.2. Freiburg: Herder, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gijsel, Jan. "), _c('em', [_vm._v("Libri de nativitate Mariae: Pseudo-Matthaei Evangelium, textus et commentarius, Libellus de nativitate sanctae Mariae, textus et commentarius")]), _vm._v(". CCSA 9. Turnhout: Brepols, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Gounelle, Rémi. “Une légende apocryphe relatant la rencontre du bon larron et de la sainte famille en Égypte ("), _c('em', [_vm._v("BHG")]), _vm._v(" 2119y).” "), _c('em', [_vm._v("AnBoll")]), _vm._v(" 121 (2003): 241–72.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kretzenbacher, Leopold. “St. Dismas, der rechte Schächter: Legenden, Kultstätten und Verehrungsformen in Innerösterreich.” "), _c('em', [_vm._v("Zeitschrift des Historischen Vereines für Steiermark")]), _vm._v(" 42 (1951): 119–39.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Philippart, Guy. “Le Pseudo-Matthieu au risque de la critique textuelle.” "), _c('em', [_vm._v("Scriptorium")]), _vm._v(" 38, no. 1 (1984): 121–31.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_001",
      "id": "foot-001"
    }
  }, [_vm._v("1")]), _vm._v(". Gijsel, "), _c('em', [_vm._v("Libri de nativitate Mariae")]), _vm._v(", 71–97; additional manuscripts are listed in Gijsel, “Nouveaux témoins du pseudo-Matthieu,” "), _c('em', [_vm._v("Sacris erudiri")]), _vm._v(" 41 (2002): 273–300.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_002",
      "id": "foot-002"
    }
  }, [_vm._v("2")]), _vm._v(". Geerard, “Le bon larron, un apocryphe inédit,” 360. My translation of "), _c('em', [_vm._v("Reb. Dimas")]), _vm._v(" appears in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2:13–22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_003",
      "id": "foot-003"
    }
  }, [_vm._v("3")]), _vm._v(". Gijsel, "), _c('em', [_vm._v("Libri de nativitate Mariae")]), _vm._v(", 163–65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_004",
      "id": "foot-004"
    }
  }, [_vm._v("4")]), _vm._v(". Geerard, “Gute Schächer.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_005",
      "id": "foot-005"
    }
  }, [_vm._v("5")]), _vm._v(". My forthcoming critical edition provides full notes and corrects nine errors in Geerard’s diplomatic edition of L. V shows a tendency to make spelling corrections (e.g., line 13 "), _c('em', [_vm._v("possitis")]), _vm._v(" L : "), _c('em', [_vm._v("positis")]), _vm._v(" V; line 31 "), _c('em', [_vm._v("alabanstri")]), _vm._v(" L : "), _c('em', [_vm._v("alabastri")]), _vm._v(" V), grammar normalizations (e.g., lines 8–9 "), _c('em', [_vm._v("interficiam")]), _vm._v(" and "), _c('em', [_vm._v("interfecero")]), _vm._v(" L : "), _c('em', [_vm._v("interficio")]), _vm._v(" V), terminological standardizations (e.g., lines 22–23 "), _c('em', [_vm._v("infantem")]), _vm._v(" and "), _c('em', [_vm._v("filium")]), _vm._v(" L : "), _c('em', [_vm._v("infantulum")]), _vm._v(" V), and pious emendations (e.g., line 21 "), _c('em', [_vm._v("pulcer")]), _vm._v(" L : "), _c('em', [_vm._v("pulcrior")]), _vm._v(" V).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_006",
      "id": "foot-006"
    }
  }, [_vm._v("6")]), _vm._v(". For a comparable overview of the sources, see Bilby, "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1:41–44. A correction should be noted here: that "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" is not, like "), _c('em', [_vm._v("Reb. Dimas")]), _vm._v(", placed “immediately after the "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" account of the palm tree” (ibid., 43), but a few paragraphs before, between "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" 17 and 18. Thus the connection between the prostrating bandit and the bending date palm in "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" 20 apparent in "), _c('em', [_vm._v("Reb. Dimas")]), _vm._v(" may not be in mind in "), _c('em', [_vm._v("Hosp. Perf. Band")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_007",
      "id": "foot-007"
    }
  }, [_vm._v("7")]), _vm._v(". Introduction and translation by Bilby in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 2:13–22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_008",
      "id": "foot-008"
    }
  }, [_vm._v("8")]), _vm._v(". Introduction and translation by Bilby in "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1:39–51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_009",
      "id": "foot-009"
    }
  }, [_vm._v("9")]), _vm._v(". Text and translation in Ehrman and Pleše, "), _c('em', [_vm._v("AG")]), _vm._v(" 147–55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_010",
      "id": "foot-010"
    }
  }, [_vm._v("10")]), _vm._v(". The Irish text and English translation appear in Martin McNamara et al., "), _c('em', [_vm._v("Apocrypha Hiberniae I. Evangelia Infantiae")]), _vm._v(", CCSA 13 (Turnhout: Brepols, 2001), 404–7; for the summation of the similar tale by Aelred of Rievaulx, see Anselm Hoste and Charles H. Talbot, eds., "), _c('em', [_vm._v("Aelredi Rievallensis Opera omnia 1: Opera ascetica")]), _vm._v(", CCCM 1 (Turnhout: Brepols, 1971), 664.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_011",
      "id": "foot-011"
    }
  }, [_vm._v("11")]), _vm._v(". The Greek text based on four manuscripts is found in Constantin Tischendorf, "), _c('em', [_vm._v("Evangelia Apocrypha")]), _vm._v(" (2nd ed.; Leipzig: Mendelssohn, 1876), 459–70, and an English translation by Ehrman and Pleše of the Tischendorf edition appears in "), _c('em', [_vm._v("AG")]), _vm._v(", 572–85. Rémi Gounelle is preparing a new critical edition of this text for CCSA.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_012",
      "id": "foot-012"
    }
  }, [_vm._v("12")]), _vm._v(". Introduction and edition in Michel van Esbroeck, “Une homélie inédite éphrémienne sur le bon larron en grec, géorgien et arabe,” "), _c('em', [_vm._v("AnBoll")]), _vm._v(" 101 (1983): 327–62.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_013",
      "id": "foot-013"
    }
  }, [_vm._v("13")]), _vm._v(". Also presented in van Esbroeck, “Une homélie inédite éphrémienne.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_014",
      "id": "foot-014"
    }
  }, [_vm._v("14")]), _vm._v(". Alphonse Mingana, “Woodbrook Studies 5: "), _c('em', [_vm._v("Vision of Theophilus")]), _vm._v(",” "), _c('em', [_vm._v("BJRL")]), _vm._v(" 13 (1929): 383–474 (repr. in "), _c('em', [_vm._v("Woodbrooke Studies: Christian Documents in Syriac, Arabic and Garshūni")]), _vm._v(","), _c('em'), _vm._v(" vol. 3 [Cambridge: Heffer & Sons, 1931], 1–92). For the story of the bandit, see pp. 19–20, 26–29.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_015",
      "id": "foot-015"
    }
  }, [_vm._v("15")]), _vm._v(". Anne Boud’hors and Ramez Boutros, "), _c('em', [_vm._v("L’homélie sur l’Église du Rocher")]), _vm._v(","), _c('em'), _vm._v(" PO 49.1 (Turnhout: Brepols, 2001), 38–47 (Coptic text and translation), 132–37 (Arabic text and translation). The Ethiopic text and translation appear in Gérard Colin, "), _c('em', [_vm._v("L’homélie sur l’Église du Rocher")]), _vm._v(","), _c('em'), _vm._v(" PO 49.2 (Turnhout: Brepols, 2001), 248–53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_016",
      "id": "foot-016"
    }
  }, [_vm._v("16")]), _vm._v(". The relevant section is translated into English in Elliott, "), _c('em', [_vm._v("ANT")]), _vm._v(", 105. The precursor to "), _c('em', [_vm._v("(Arab.) Gos. Inf")]), _vm._v(", the Syriac "), _c('em', [_vm._v("Hist. Vir")]), _vm._v("., appears in Ernest A. W. Budge, "), _c('em', [_vm._v("The History of the Blessed Virgin Mary and the History of the Likeness of Christ")]), _vm._v(" (London: Luzac, 1899). For the story of the bandit, see pp. 59–60.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_017",
      "id": "foot-017"
    }
  }, [_vm._v("17")]), _vm._v(". For the Arabic "), _c('em', [_vm._v("(Apocr.) Gos. John")]), _vm._v(", the precursor to the "), _c('em', [_vm._v("Miracles of Jesus")]), _vm._v(", see the edition of Giovanni Galbiati, "), _c('em', [_vm._v("Iohannis Evangelium apocryphum arabice")]), _vm._v(" (Milan: In aedibus Mondadorianis, 1957), 52–55 (the page numbers apply to both the Arabic text and the Latin translation). For the text and translation of the Ethiopic "), _c('em', [_vm._v("Miracles of Jesus")]), _vm._v(", see Sylvain Grébaut, "), _c('em', [_vm._v("Les Miracles de Jésus")]), _vm._v(", PO 12.4 (Paris: Firmin-Didot, 1919), 618–23. The Ethiopic version introduces a number of significant errors and changes. Most notable for our purposes is the addition of the third bandit character (“Gamhour”) because of a mistranslation of the Arabic word for “multitude” ("), _c('em', [_vm._v("gamhur")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_018",
      "id": "foot-018"
    }
  }, [_vm._v("18")]), _vm._v(". Bilby, "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1:43.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_019",
      "id": "foot-019"
    }
  }, [_vm._v("19")]), _vm._v(". "), _c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(" ("), _c('em', [_vm._v("Birth Sav.")]), _vm._v(") 123–24.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_020",
      "id": "foot-020"
    }
  }, [_vm._v("20")]), _vm._v(". The parallel is explicit in "), _c('em', [_vm._v("Hosp. Oint. Band.")]), _vm._v(" ("), _c('em', [_vm._v("Birth Sav.")]), _vm._v(") 116; see Ehrman and Pleše, "), _c('em', [_vm._v("AG")]), _vm._v(", 148–49. It is implicit in "), _c('em', [_vm._v("Hosp. Perf. Band.")]), _vm._v(" in the placement of the bandit’s short story just before the episode of the cave of dragons ("), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" 18).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_021",
      "id": "foot-021"
    }
  }, [_vm._v("21")]), _vm._v(". The earliest known manuscript is Montpellier, Bibliothèque de la Faculté de medicine, 55 (ca. 800) (= Gijsel Ja1 [M"), _c('sup', [_vm._v("1")]), _vm._v("]). See Gijsel, "), _c('em', [_vm._v("Libri de nativitate Mariae")]), _vm._v(", 213.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_022",
      "id": "foot-022"
    }
  }, [_vm._v("22")]), _vm._v(". Gounelle, “Une légende apocryphe,” 247–48; see also Bilby, "), _c('em', [_vm._v("MNTA")]), _vm._v(" 1:44–45.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_023",
      "id": "foot-023"
    }
  }, [_vm._v("23")]), _vm._v(". Online at "), _c('a', {
    attrs: {
      "href": "http://www.bl.uk/manuscripts/FullDisplay.aspx?ref=Harley_MS_3199",
      "target": "_blank"
    }
  }, [_vm._v("http://www.bl.uk/manuscripts/FullDisplay.aspx?ref=Harley_MS_3199")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ch-titlep"
  }, [_vm._v("The Hospitality and Perfume of the Bandit")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("How Mary and Joseph fled to Egypt with Jesus and about the bandit whom they encountered in the desert."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-024",
      "id": "foot_024"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("1")]), _vm._v("(17.3a) At the time when blessed Mary and Joseph headed through the desert, they encountered a bandit who was hiding in a forest. To him it had been commanded by the other bandits, if he encountered anyone, to kill him immediately and bring them the spoils taken"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-025",
      "id": "foot_025"
    }
  }, [_vm._v("b")])]), _vm._v(" from him. Otherwise, he could not live with them.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 2:14")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("(Arab.) Gos. Inf.")]), _vm._v(" 23; "), _c('em', [_vm._v("Birth Sav.")]), _vm._v(" 111")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The bandit ponders his plan")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("2")]), _vm._v("(17.3b) When"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-026",
      "id": "foot_026"
    }
  }, [_vm._v("c")])]), _vm._v(" it happened that Joseph and the blessed Mary encountered him on the desert road, when that bandit saw them,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-027",
      "id": "foot_027"
    }
  }, [_vm._v("d")])]), _vm._v(" he reflected intensively within himself and said,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-028",
      "id": "foot_028"
    }
  }, [_vm._v("e")])]), _vm._v(" “O Lord God, what shall I do? I have sworn to kill all men whom I discover"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-029",
      "id": "foot_029"
    }
  }, [_vm._v("f")])]), _vm._v(" in this desert. If I forswear,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-030",
      "id": "foot_030"
    }
  }, [_vm._v("g")])]), _vm._v(" it is wrong. If I kill this old man, what benefit is it to me? If I kill the boy’s mother and the boy, it is even worse. But"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-031",
      "id": "foot_031"
    }
  }, [_vm._v("h")])]), _vm._v(" what will I do? I will lead them covertly to my house, and I will show love toward them, because they will not find hospitality"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-032",
      "id": "foot_032"
    }
  }, [_vm._v("i")])]), _vm._v(" in a desert.”")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The bandit inquires and offers hospitality")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("3")]), _vm._v("(17.3c) And he said to them, “Brothers,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-033",
      "id": "foot_033"
    }
  }, [_vm._v("j")])]), _vm._v(" why do you head through this desert with this lady and with"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-034",
      "id": "foot_034"
    }
  }, [_vm._v("k")])]), _vm._v(" this boy and with this family—in a place where you will not find a place or houses where you can rest with this infant and with your animals? Where are you going? Where are you headed?” Joseph responded to him and said, “Our journey is to Egypt.” The bandit responded to him, “My brothers,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-035",
      "id": "foot_035"
    }
  }, [_vm._v("a")])]), _vm._v(" I ask,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-036",
      "id": "foot_036"
    }
  }, [_vm._v("b")])]), _vm._v(" if it pleases you, to come with me to my hospitality at this late hour and be guests with me. For long is the road"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-037",
      "id": "foot_037"
    }
  }, [_vm._v("c")])]), _vm._v(" and harsh through this desert.” And they left with him and entered into a certain small house in which he"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-038",
      "id": "foot_038"
    }
  }, [_vm._v("d")])]), _vm._v(" and his wife was living."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-039",
      "id": "foot_039"
    }
  }, [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" 3; "), _c('em', [_vm._v("Birth Sav.")]), _vm._v(" 117")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" 4")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The healing of the bandit’s child")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("4")]), _vm._v("(17.3d) From this wife he had a little son, but"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-040",
      "id": "foot_040"
    }
  }, [_vm._v("f")])]), _vm._v(" he was quite leprous, indeed scabby. But since the hour for bathing his son had now approached, the bandit said to his wife, “Allow this infant to be bathed first, because he is beautiful,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-041",
      "id": "foot_041"
    }
  }, [_vm._v("g")])]), _vm._v(" and you can bathe our infant afterward, because he is scabby and quite leprous.” But after the blessed Mary had bathed her son"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-042",
      "id": "foot_042"
    }
  }, [_vm._v("h")])]), _vm._v(" Jesus, as the bandit’s son was bathed in the same water, immediately he was totally cleansed from all filth and from every infirmity. And the bandit said to his wife, “Truly this is the Son of God.” And he fell prostrate on the ground and worshiped him.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" 5")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Birth Sav.")]), _vm._v(" 117")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("(Arab.) Gos. Inf.")]), _vm._v(" 17–18, 27, 28, 31, 32, 33")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Matt 14:33; 27:54; Mark 15:39")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The bandit’s protection and Mary’s reward")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("5")]), _vm._v("(17.3e) As is proper, on the next day they rose up and left. And the bandit likewise went with them to show them the way and to help them until midday until they came to a certain fountain. But"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-043",
      "id": "foot_043"
    }
  }, [_vm._v("i")])]), _vm._v(" after they reached the fountain, they stayed there. And there the blessed Mary washed the little garments of her boy"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-044",
      "id": "foot_044"
    }
  }, [_vm._v("j")])]), _vm._v(" Jesus, and from the water she wrung from them she filled one vessel of alabaster. And immediately this water produced a precious and exceedingly fragrant perfume, whose aroma no one can narrate in the least. Afterward, the blessed Mary took this vessel and said to the bandit, “Brothers,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-045",
      "id": "foot_045"
    }
  }, [_vm._v("k")])]), _vm._v(" take this vessel, because to us you exhibited great service. Though we do not have gold or silver to give you, I give you this great vessel because you are able to present what is inside it as if it were gold assayed in the market.”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" 8")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("(Arab.) Gos. Inf.")]), _vm._v(" 24; "), _c('em', [_vm._v("Birth Sav.")]), _vm._v(" 117")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 14:3 par.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Acts 3:6")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The bandit sells the perfume to Mary Magdalene")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("6")]), _vm._v("(17.3f) Then"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-046",
      "id": "foot_046"
    }
  }, [_vm._v("l")])]), _vm._v(" the bandit received it from the hands of the blessed Mary and it served him on many occasions, such as when the time came that he and his wife fell into great and terrible poverty. Yet at that time, he was reminded of the word that the blessed Mary had spoken to him about the vessel that she had given him. Then he went and took it and carried it to a castle where Mary Magdalene was at"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-047",
      "id": "foot_047"
    }
  }, [_vm._v("a")])]), _vm._v(" that time making a living from sin. And he said, “There is in this country"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-048",
      "id": "foot_048"
    }
  }, [_vm._v("b")])]), _vm._v(" no other person who uses precious"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-049",
      "id": "foot_049"
    }
  }, [_vm._v("c")])]), _vm._v(" perfumes more than Mary Magdalene. I will go and I will sell it for as much as I can.” And he went to her and sold it"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-050",
      "id": "foot_050"
    }
  }, [_vm._v("d")])]), _vm._v(" for a lot of money.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_c('em', [_vm._v("Birth Sav.")]), _vm._v(" 123–24")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Conclusion: The aftermath of the perfume in the Gospels")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('sup', [_vm._v("7")]), _vm._v("(17.3g) And immediately when Mary Magdalene anointed herself with"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-051",
      "id": "foot_051"
    }
  }, [_vm._v("e")])]), _vm._v(" the aforementioned perfume, all bodily pollution and desire for sinning left her."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-052",
      "id": "foot_052"
    }
  }, [_vm._v("f")])]), _vm._v(" What was left over she kept for later, until the time when she was converted and anointed the feet of the Lord and Savior at the time of the passion. And this was the bandit whom the Jews crucified with Jesus our Lord, the one who said, “"), _c('em', [_vm._v("Remember me")]), _vm._v(", Lord, "), _c('em', [_vm._v("when")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#foot-053",
      "id": "foot_053"
    }
  }, [_vm._v("g")])]), _vm._v(" "), _c('em', [_vm._v("you come into your kingdom.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Luke 8:2; Mark 16:9")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Mark 14:3–9 par.")]), _vm._v(" "), _c('p', {
    staticClass: "sidenote"
  }, [_vm._v("Luke 23:42; "), _c('em', [_vm._v("Hosp. Dysmas")]), _vm._v(" 9")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_024",
      "id": "foot-024"
    }
  }, [_vm._v("a")]), _vm._v(". L starts the narrative on a new page and places this title in red at the top right of fol. 105v. The interpolation in V is seamlessly interwoven into "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" without title.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_025",
      "id": "foot-025"
    }
  }, [_vm._v("b")]), _vm._v(". V: “taken immediately.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_026",
      "id": "foot-026"
    }
  }, [_vm._v("c")]), _vm._v(". V: “Next.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_027",
      "id": "foot-027"
    }
  }, [_vm._v("d")]), _vm._v(". L lacks “them.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_028",
      "id": "foot-028"
    }
  }, [_vm._v("e")]), _vm._v(". V: “he thought intensively and said within himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_029",
      "id": "foot-029"
    }
  }, [_vm._v("f")]), _vm._v(". V: “I might discover.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_030",
      "id": "foot-030"
    }
  }, [_vm._v("g")]), _vm._v(". V: “swear by God.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_031",
      "id": "foot-031"
    }
  }, [_vm._v("h")]), _vm._v(". G omits “but” ("), _c('em', [_vm._v("sed")]), _vm._v("), present in L and V.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_032",
      "id": "foot-032"
    }
  }, [_vm._v("i")]), _vm._v(". V: “any other hospitality.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_033",
      "id": "foot-033"
    }
  }, [_vm._v("j")]), _vm._v(". G reads “brother” ("), _c('em', [_vm._v("frater")]), _vm._v("), but L and V have the plural ("), _c('em', [_vm._v("fratres")]), _vm._v("). The plural in this interpolation may foreshadow "), _c('em', [_vm._v("Ps.-Mt.")]), _vm._v(" 18, where “three male servants” and “one maidservant” are mentioned as traveling companions.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_034",
      "id": "foot-034"
    }
  }, [_vm._v("k")]), _vm._v(". V lacks “with.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_035",
      "id": "foot-035"
    }
  }, [_vm._v("a")]), _vm._v(". G again erroneously reads “brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_036",
      "id": "foot-036"
    }
  }, [_vm._v("b")]), _vm._v(". V: “ask you.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_037",
      "id": "foot-037"
    }
  }, [_vm._v("c")]), _vm._v(". V: “the road is long.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_038",
      "id": "foot-038"
    }
  }, [_vm._v("d")]), _vm._v(". V: “the bandit.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_039",
      "id": "foot-039"
    }
  }, [_vm._v("e")]), _vm._v(". V: “were living.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_040",
      "id": "foot-040"
    }
  }, [_vm._v("f")]), _vm._v(". V: “and.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_041",
      "id": "foot-041"
    }
  }, [_vm._v("g")]), _vm._v(". V: “more beautiful.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_042",
      "id": "foot-042"
    }
  }, [_vm._v("h")]), _vm._v(". V: “infant.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_043",
      "id": "foot-043"
    }
  }, [_vm._v("i")]), _vm._v(". V: “and.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_044",
      "id": "foot-044"
    }
  }, [_vm._v("j")]), _vm._v(". V: “son.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_045",
      "id": "foot-045"
    }
  }, [_vm._v("k")]), _vm._v(". V: “Brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_046",
      "id": "foot-046"
    }
  }, [_vm._v("l")]), _vm._v(". V: “Whereupon.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_047",
      "id": "foot-047"
    }
  }, [_vm._v("a")]), _vm._v(". V: “in.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_048",
      "id": "foot-048"
    }
  }, [_vm._v("b")]), _vm._v(". G reads “province” ("), _c('em', [_vm._v("prouincia")]), _vm._v("), but V and L have “country” ("), _c('em', [_vm._v("patria")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_049",
      "id": "foot-049"
    }
  }, [_vm._v("c")]), _vm._v(". V: “more precious.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_050",
      "id": "foot-050"
    }
  }, [_vm._v("d")]), _vm._v(". V: “the same perfume.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_051",
      "id": "foot-051"
    }
  }, [_vm._v("e")]), _vm._v(". V: “from.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_052",
      "id": "foot-052"
    }
  }, [_vm._v("f")]), _vm._v(". It should be noted that the woman in Luke 7:36–50 is not identified as Mary Magdalene.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_053",
      "id": "foot-053"
    }
  }, [_vm._v("g")]), _vm._v(". L: “as.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c54bf9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010_Chapter01.vue
// module id = 84
// module chunks = 0